
import Helper from '@/Helper'
export default {
  getChecklistItemOfGroupChecklist (state, payload) {
    return state.checklist.checklist_items
  },
  getUserOfChecklist (state) {
    return state.checklist.checklist_users.map(item => {
      var data = item
      data.users = item.users.sort((a, b) => b.position_order - a.position_order)
      return data
    })
  },
  getGroupOfChecklist (state) {
    return state.checklist.group_checklist_items
  },
  getComplete (state) {
    var data = []
    state.checklist.group_checklist_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    var total = data.reduce(function (total, item) {
      return total + item.total
    }, 0)
    var isCheck = data.reduce(function (total, item) {
      return total + item.is_check
    }, 0)
    return ((isCheck / total) * 100).toFixed(2)
  },
  getQuickReport (state) {
    return state.checklist.quick_reports
  },
  getLabelQuickReport (state) {
    let labels = []
    state.checklist.quick_reports.forEach(element => {
      labels.push(element.code + '-' + element.name)
    })
    return labels
  },
  getDataQuickReport (state) {
    let data = []
    state.checklist.quick_reports.forEach(element => {
      data.push(element.total)
    })
    return data
  },
  getBackgroundColorQuickReport (state) {
    let colors = []
    state.checklist.quick_reports.forEach(element => {
      colors.push(element.color)
    })
    return colors
  },
  getSelectStatus (state) {
    return state.checklist.select_status
  }
}



// WEBPACK FOOTER //
// ./src/store/module/audit/getters.js